import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFileBlank = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 21,
	viewBox: "0 0 16 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.937 7.40754C15.926 7.37554 15.917 7.34454 15.904 7.31354C15.8566 7.20501 15.7902 7.10579 15.708 7.02054L9.708 1.02054C9.62275 0.938321 9.52353 0.87195 9.415 0.824539C9.385 0.810539 9.353 0.802539 9.321 0.791539C9.23733 0.763065 9.15022 0.745913 9.062 0.740539C9.04 0.738539 9.021 0.727539 9 0.727539H2C0.897 0.727539 0 1.62454 0 2.72754V18.7275C0 19.8305 0.897 20.7275 2 20.7275H14C15.103 20.7275 16 19.8305 16 18.7275V7.72754C16 7.70654 15.989 7.68754 15.987 7.66554C15.9819 7.5777 15.9651 7.49094 15.937 7.40754ZM12.586 6.72754H10V4.14154L12.586 6.72754ZM2 18.7275V2.72754H8V7.72754C8 7.99276 8.10536 8.24711 8.29289 8.43465C8.48043 8.62218 8.73478 8.72754 9 8.72754H14L14.002 18.7275H2Z",
		fill: "currentColor"
	})
});
export default SvgFileBlank;
